module.exports = ".cursor-pointer {\n    cursor: pointer;\n}\n\n.advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}\n\n.geo-content__row.second {\n    padding: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/viagens/deslocamentos/deslocamento-history/deslocamento-history.component.css
 ** module id = 461
 ** module chunks = 0
 **/